import { isArray } from 'lodash';

import * as turfDistance from '@turf/distance';
import * as turfBearing from '@turf/bearing';

import { LatLng } from 'leaflet';

const distanceOptions = { units: 'kilometers' };

export const distance = (from: LatLng, to: LatLng) => {
  if (!isArray(from) && !isArray(to)) {
    // @ts-ignore
    return turfDistance.default([from.lat, from.lng], [to.lat, to.lng], distanceOptions);
  }
  if (isArray(from) && isArray(to)) {
    // @ts-ignore
    return turfDistance.default(from, to, distanceOptions);
  }
  // Type mismatch
  return -1;
};

export const bearing = (from: LatLng, to: LatLng) => {
  if (!isArray(from) && !isArray(to)) {
    return turfBearing.default([from.lat, from.lng], [to.lat, to.lng]);
  }
  if (isArray(from) && isArray(to)) {
    return turfBearing.default(from, to);
  }
  // Type mismatch
  return -1;
};
